<template>
    <div class="min-h-screen flex flex-col sm:justify-center items-center pt-12">
        <div>
            <slot name="logo" />
        </div>

        <div class="flex justify-center px-4 w-full">
            <div class="max-w-md mb-6 mt-8 p-6 bg-white shadow-md rounded-2xl w-full">
                <slot />
            </div>
        </div>
    </div>
</template>
